import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierObjectionLookup extends Layout {
    sourceCarrierObjection: DataSource;
    tableObjections: Table;
}
